import { defineMutator } from "@rocicorp/zero"

import type { ZeroJwtPayload } from "@productlane/lib/src/browser"

import type { MutatorTx } from "../schema"
import type {
	CreateSnippetFolderArgs,
	DeleteSnippetFolderArgs,
	UpdateSnippetFolderArgs,
} from "../types"

export const snippetFolderMutators = {
	create: defineMutator(
		async ({
			tx,
			args,
			ctx: authData,
		}: {
			tx: MutatorTx
			args: CreateSnippetFolderArgs
			ctx: ZeroJwtPayload
		}) => {
			await tx.mutate.snippetFolders.insert({
				id: args.id,
				name: args.name,
				icon: args.icon,
				createdAt: Date.now(),
				updatedAt: Date.now(),
				isDeleted: false,
				workspaceId: authData.workspaceId,
			})
		},
	),
	update: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: UpdateSnippetFolderArgs }) => {
			await tx.mutate.snippetFolders.update({
				id: args.id,
				name: args.name,
				icon: args.icon,
			})
		},
	),
	delete: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: DeleteSnippetFolderArgs }) => {
			// Snippets in the folder become uncategorized
			const snippets = await tx.query.snippets.where("folderId", args.id).run()

			await Promise.all(
				snippets.map((snippet) =>
					tx.mutate.snippets.update({ id: snippet.id, folderId: null }),
				),
			)

			await tx.mutate.snippetFolders.update({
				id: args.id,
				isDeleted: true,
			})
		},
	),
}
